<template>
    <div>
        <Title :title="'证书审核'" :noBorder="true"></Title>
        <Menu mode="horizontal" :theme="'light'" active-name="1" class="tabs">
            <MenuItem name="1">
                全部列表
            </MenuItem>
            <MenuItem name="2">
                待审核列表
            </MenuItem>
            <MenuItem name="3">
                已审核列表
            </MenuItem>
        </Menu>
        <div class="table-box">
            <Table height="200" :columns="columns" :data="data"></Table>
        </div>
    </div>
</template>

<script>
    import Title from "./title";

    export default {
        name: "certificate",
        components: {
            Title
        },
        data(){
            return{
                data:[],
                columns:[
                    {
                        title: 'ID',
                        key: 'id'
                    },
                    {
                        title: '学生姓名',
                        key: 'name'
                    },
                    {
                        title: '学生账号',
                        key: 'number'
                    },
                    {
                        title: '所属班级',
                        key: 'class'
                    },
                    {
                        title: '所属学院',
                        key: 'xueyuan'
                    },
                    {
                        title: '状态',
                        key: 'status'
                    },
                    {
                        title: '操作',
                        key: 'caozuo'
                    },
                ]
            }
        }
    }
</script>

<style scoped>
.tabs{
    background: #ffffff;
    height: 40px;
    line-height: 40px;
}
    .table-box{
        background: #ffffff;
        margin: 20px;
        border: 1px solid #dddddd;
    }
</style>